import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  dialog: {
    width: '560px',
    maxWidth: 'calc(100% - 32px)',
    boxShadow: '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
  },
  title: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 48px 8px 24px',
    '& .myev-MuiTypography-h3': {
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '27px',
      color: theme.evPalette.charcoal[900],
      textTransform: 'none',
    },
  },
  closeButton: {
    position: 'absolute',
    top: 24,
    right: 24,
    cursor: 'pointer',
    fontSize: '20px',
    color: theme.evPalette.charcoal[700],
  },
  content: {
    padding: '8px 24px 16px',
  },
  bodyText: {
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.evPalette.charcoal[800],
    marginBottom: 16,
  },
  selectedCount: {
    fontWeight: 700,
  },
  metaItem: {
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.evPalette.charcoal[900],
    marginBottom: 8,
  },
  metaLabel: {
    fontWeight: 700,
  },
  checkboxWrap: {
    marginTop: 16,
    '& > div': {
      alignItems: 'flex-start',
    },
    '& p': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  errorText: {
    color: theme.evPalette.rose[700],
    fontSize: '14px',
    marginTop: 12,
  },
  actions: {
    padding: '8px 24px 24px',
    '&>button': {
      textTransform: 'none',
      fontSize: '16px',
    },
  },
}));
